<template>
    <div class="container">
      <div class="dotest">
        <div class="left">象棋{{levelexam}}考试</div>
        <div class="right">考试剩余时间：<span class="time">{{countDownMinute}}:{{countDownSecond}}</span></div>
      </div>
      <div class="dotest_content">
        <div class="item_left">
          <div class="info">
            <div class="item_title">考生信息</div>
            <div class="item_info">考生姓名：{{name}}</div>
            <div class="item_info">考试时间：{{minute}}分钟</div>
            <div class="item_info">考试题数：{{questionNum}}</div>
            <div class="item_info">通过标准：12/20</div>
          </div>
          <div class="selected">
            <div class="item_chess" :class="moduleindex === 0 ? 'item-chesses' :''">{{chess1}}</div>
            <div class="item_chess" :class="moduleindex === 1 ? 'item-chesses' :''">{{chess2}}</div>
            <div class="item_chess" :class="moduleindex === 2 ? 'item-chesses' :''">{{chess3}}</div>
          </div>
          <div class="select" v-if="moduleindex !== 2">
            <div class="item_choose" v-for="(item,index) in enrollItemBanks" :key="index"
                 :class="index === testIndex ? 'item_chooses' :''"
                 :style="{background:item.color}"
                 @click="toTegional(index)">{{index + 1}}</div>
          </div>
           <div class="select" v-else>
            <div class="item_choose" v-for="(item,index) in walkingEnrollItemBanks[0]" :key="index"
                 :class="index === testIndex ? 'item_chooses' :''"
                 :style="{background:item.color}"
                >{{index + 1}}</div>
          </div>
        </div>
        <div class="item-rigts"  v-if="moduleindex !== 2">
          <div class="cons" v-if="enrollItemBanks[testIndex]">
            <div class="testtitle"><span>{{testIndex + 1}}.</span>{{enrollItemBanks[testIndex].title}}</div>
            <div class="testimg" v-show="enrollItemBanks[testIndex].image">
              <img :src="enrollItemBanks[testIndex].image">
            </div>
            <div class="selected"><span>A、</span>{{enrollItemBanks[testIndex].answerA}}</div>
            <div class="selected"><span>B、</span>{{enrollItemBanks[testIndex].answerB}}</div>
            <div class="selected" v-show="enrollItemBanks[testIndex].answerC"><span>C、</span>{{enrollItemBanks[testIndex].answerC}}</div>
          </div>
          <div class="selects">
            <div class="item_circle">
              <div class="circle" :class="selectA ? 'circles' :''" @click="chooseSelectA('A', enrollItemBanks[testIndex].rightKey)"></div>
              <span>A</span>
            </div>
            <div class="item_circle">
              <div class="circle" :class="selectB ? 'circles' :''" @click="chooseSelectB('B', enrollItemBanks[testIndex].rightKey)"></div>
              <span>B</span>
            </div>
            <div class="item_circle" v-if="enrollItemBanks[testIndex].answerC" >
              <div class="circle" :class="selectC ? 'circles' :''" @click="chooseSelectC('C', enrollItemBanks[testIndex].rightKey)"></div>
              <span>C</span>
            </div>
          </div>
          <div class="btn_box">
            <el-button class="item_box" :class="testIndex===0 ? '' :'item_boxs'" @click="lastTest(testIndex)" :disabled="testIndex===0">上一题</el-button>
            <div class="item_word">当前第{{testIndex+1}}题/共计{{total}}道题</div>
            <el-button  :class="testIndex+1===total ? 'item_box' :'item_boxs'" @click="nextTest(testIndex)" :disabled="testIndex+1===total" >下一题</el-button>
            <el-button class="item_boxs" @click="nextmodule()">下一模块</el-button>
          </div>
        </div>
        <cet-go-chess
          v-else
         :go-chess="walkingEnrollItemBanks"
         :select-sum="selectsum"
         @gochessnum="pgochessnum"
         @gochestest="pgochestest"></cet-go-chess>
      </div>
    </div>
</template>

<script>
import {getWalkingEnrollItemBank12, updateEnrollFractionById} from '../../api/index'
import cetGoChess from '../../components/cetGoChess.vue'
export default {
  components: { cetGoChess },
  name: 'chessCet11',
  data () {
    return {
      name: '',
      levelexam: '',
      testId: '',
      exchangCode: '',
      countDownDay: 0,
      countDownHour: 0,
      countDownMinute: 0,
      countDownSecond: 0,
      questionNum: 0,
      enrollItemBanks: [],
      testIndex: 0,
      selectA: false,
      selectB: false,
      selectC: false,
      total: 0,
      selects: [],
      sel: '',
      sum: 0,
      rightKey: [],
      gradId: '',
      totalSecond: 0,
      minute: 0,
      moduleindex: 0,
      moduleChess: [],
      walkingEnrollItemBanks: [],
      module1chess: 0,
      module2chess: 0,
      selectsum: 0,
      success: 0,
      tenrollItemBanks: [],
      selectbox: false,
      sum1: 0,
      sum2: 0,
      chess1: '',
      chess2: '',
      chess3: ''
    }
  },
  created () {
    this.name = this.$route.params.name
    this.levelexam = this.$route.params.levelexam
    this.testId = this.$route.params.id
    this.exchangCode = this.$route.params.exchangCode
    this.gradId = this.$route.params.testId
    console.log(this.name, this.levelexam, this.testId, this.exchangCode)
    let studentInfo = {
      name: this.name,
      levelexam: this.levelexam,
      gradId: this.gradId,
      exchangCode: this.exchangCode,
      testId: this.testId
    }
    localStorage.setItem('studentInfo', JSON.stringify(studentInfo))
     if (this.levelexam === '八级') {
      this.chess1 = '开局选择'
      this.chess2 = '中局战术'
      this.chess3 = '残局进阶'
    } else if (this.levelexam === '九级') {
      this.chess1 = '开局选择'
      this.chess2 = '中局战术'
      this.chess3 = '杀法闯关'
    } else if (this.levelexam === '十级') {
      this.chess1 = '开局理论'
      this.chess2 = '得子技巧'
      this.chess3 = '基础残局'
    } else if (this.levelexam === '十一级') {
      this.chess1 = '开局理论'
      this.chess2 = '开局定式'
      this.chess3 = '杀法闯关'
    }else if (this.levelexam === '十三级') {
      this.chess1 = '开局选择'
      this.chess2 = '抽吃战术'
      this.chess3 = '杀法闯关'
    }else if (this.levelexam === '十二级') {
      this.chess1 = '常见手法（上）'
      this.chess2 = '常见手法（下）'
      this.chess3 = '杀法闯关'
    }else{
      this.chess1 = '开局定式'
      this.chess2 = '中局技巧'
      this.chess3 = '杀法进阶'
    }
    this.getTest(this.testId, this.exchangCode)
    if(this.levelexam === '十三级'){
      this.minute = 30
      this.questionNum = 20
      this.totalSecond = 1800
    }else  if(this.levelexam === '十二级'){
      this.minute = 45
      this.questionNum = 20
      this.totalSecond = 2700
    }else{
      this.minute = 60
      this.questionNum = 20
      this.totalSecond = 3600
    }
    // var totalSecond = 1800
    var interval = setInterval(function () {
      // 秒数
      var second = this.totalSecond
      // 天数位
      var day = Math.floor(second / 3600 / 24)
      var dayStr = day.toString()
      if (dayStr.length === 1) dayStr = '0' + dayStr
      // 小时位
      var hr = Math.floor((second - day * 3600 * 24) / 3600)
      var hrStr = hr.toString()
      if (hrStr.length === 1) hrStr = '0' + hrStr
      // 分钟位
      var min = Math.floor((second - day * 3600 * 24 - hr * 3600) / 60)
      var minStr = min.toString()
      if (minStr.length === 1) minStr = '0' + minStr
      // 秒位
      var sec = second - day * 3600 * 24 - hr * 3600 - min * 60
      var secStr = sec.toString()
      if (secStr.length === 1) secStr = '0' + secStr
      this.countDownDay = dayStr
      this.countDownHour = hrStr
      this.countDownMinute = minStr
      this.countDownSecond = secStr
      this.totalSecond--
      if (this.totalSecond < 0) {
        clearInterval(interval)
        // 提交答案
        // 跳转页
        let fraction = Number(this.success) + Number(this.selectsum)
        console.log('fraction', fraction)
        this.updateEnrollFractionById(fraction)
      }
    }.bind(this), 1000)
  },
  methods: {
    getTest (id, exchangCode) {
      getWalkingEnrollItemBank12({
        enrollGradeId: id,
        exchangCode: exchangCode
      }).then(res => {
        // success
        console.log('数据', res)
        this.tenrollItemBanks = res.enrollItemBanks
        console.log('this.tenrollItemBanks', this.tenrollItemBanks)
        this.enrollItemBanks = this.tenrollItemBanks[this.moduleindex]
        this.walkingEnrollItemBanks = res.walkingEnrollItemBanks
        console.log(this.moduleindex)
        if (this.moduleindex !== 2) {
          this.total = this.enrollItemBanks.length
        } else {
          this.total = res.walkingEnrollItemBanks[0].length
          console.log(this.total)
        }
      }).catch(() => {
        // console.log('取消')
      })
    },
    toTegional (index) {
      this.testIndex = index
      if (this.selects[this.testIndex] === 'A') {
        this.selectA = true
        this.selectB = false
        this.selectC = false
      } else if (this.selects[this.testIndex] === 'B') {
        this.selectB = true
        this.selectA = false
        this.selectC = false
      } else if (this.selects[this.testIndex] === 'C') {
        this.selectC = true
        this.selectA = false
        this.selectB = false
      } else {
        this.selectC = false
        this.selectA = false
        this.selectB = false
      }
    },
    chooseSelectA (selA, right) {
      this.selectA = true
      this.selectB = false
      this.selectC = false
      // console.log(selA, right)
      this.selects[this.testIndex] = selA
      this.rightKey[this.testIndex] = right
      // console.log('选择A：', this.selects)
      // console.log('答案：', this.rightKey)
    },
    chooseSelectB (selB, right) {
      this.selectB = true
      this.selectA = false
      this.selectC = false
      this.selects[this.testIndex] = selB
      this.rightKey[this.testIndex] = right
      // console.log('选择B：', this.selects)
      // console.log('答案：', this.rightKey)
    },
    chooseSelectC (selC, right) {
      this.selectC = true
      this.selectA = false
      this.selectB = false
      this.selects[this.testIndex] = selC
      this.rightKey[this.testIndex] = right
      // console.log('选择C：', this.selects)
      // console.log('答案：', this.rightKey)
    },
    lastTest (index) {
      if (index > 0) {
        this.testIndex--
        // eslint-disable-next-line no-unused-expressions
        if (this.selects[this.testIndex] === 'A') {
          this.selectA = true
          this.selectB = false
          this.selectC = false
        } else if (this.selects[this.testIndex] === 'B') {
          this.selectB = true
          this.selectA = false
          this.selectC = false
        } else if (this.selects[this.testIndex] === 'C') {
          this.selectC = true
          this.selectA = false
          this.selectB = false
        } else {
          this.selectC = false
          this.selectA = false
          this.selectB = false
        }
        this.$emit('childtestIndex', this.testIndex)
      }
    },
    nextTest (index) {
      if (index <= this.total) {
        this.testIndex++
        this.$emit('childtestIndex', this.testIndex)
        if (this.selects[this.testIndex] === 'A') {
          this.selectA = true
          this.selectB = false
          this.selectC = false
        } else if (this.selects[this.testIndex] === 'B') {
          this.selectB = true
          this.selectA = false
          this.selectC = false
        } else if (this.selects[this.testIndex] === 'C') {
          this.selectC = true
          this.selectA = false
          this.selectB = false
        } else {
          this.selectC = false
          this.selectA = false
          this.selectB = false
        }
        this.sel = ''
      }
    },
    nextmodule () {
      this.$confirm('请仔细检查当前模块是否填写完毕，点击确定按钮后，将不会退回到当前模块', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        this.moduleindex = this.moduleindex + 1
        console.log(this.moduleindex, 'this.moduleindex')
        if (this.moduleindex === 1) {
          let sum1 = 0
          this.testIndex = 0
          this.moduleChess1 = this.selects
          this.moduleChess1Right = this.rightKey
          this.rightKey = []
          this.selects = []
          this.selectA = false
          this.selectB = false
          this.selectC = false
          for (var i = 0; i < this.moduleChess1.length; i++) {
            if (this.moduleChess1[i] === this.moduleChess1Right[i]) {
              sum1 = sum1 + 1
            }
          }
          this.enrollItemBanks = this.tenrollItemBanks[this.moduleindex]
          console.log('sum1', sum1)
          this.sum1 = sum1
        }
        if (this.moduleindex === 2) {
          let sum2 = 0
          this.testIndex = 0
          for (let i = 0; i < this.selects.length; i++) {
            if (this.selects[i] === this.rightKey[i]) {
              sum2 = sum2 + 1
            }
          }
          this.sum2 = sum2
          console.log('sum2', sum2)
          this.selectsum = this.sum1 + this.sum2
          let array = []
          array.push(this.walkingEnrollItemBanks)
          array.push(this.selectsum)
          console.log(array)
          this.walkingEnrollItemBanks = array
          console.log('之后', this.walkingEnrollItemBanks)
        }
      }).catch(() => {
        // console.log('取消')
      })
    },
    ptestindex (data) {
      this.testIndex = data
      console.log('this.testIndex1', this.testIndex, data)
    },
    pmodlueindex (res) {
      this.moduleindex = res
      console.log('this.moduleindex', this.moduleindex, res)
      this.enrollItemBanks = this.tenrollItemBanks[this.moduleindex]
      if (this.moduleindex === 2) {
        console.log('之前', this.walkingEnrollItemBanks)
        let array = []
        array.push(this.walkingEnrollItemBanks)
        array.push(this.selectsum)
        console.log(array)
        this.walkingEnrollItemBanks = array
        console.log('之后', this.walkingEnrollItemBanks)
      }
    },
    pmodule1chess (data) {
      this.module1chess = data
      console.log('this.module1chess', this.module1chess, data)
    },
    pmodule2chess (data) {
      this.module2chess = data
      console.log(' this.module2chess', this.module2chess, data)
      this.selectsum = this.module1chess + this.module2chess
      console.log(' this.selectsum', this.selectsum)
    },
    pgochessnum (num) {
      this.success = num
      console.log(this.success, 'this.this.success')
    },
    pgochestest (event) {
      this.testIndex = event
      console.log(event, 'this.testIndex')
    },
    // 提交闯关结果
    updateEnrollFractionById (fraction) {
      updateEnrollFractionById({
        id: this.gradId,
        fraction: fraction
      }).then(res => {
        // success
        console.log(res)
        this.$router.push({
          name: 'gradingResults',
          // name: 'mallList',
          query: {
            id: this.gradId,
            fractions: fraction,
            levelexam: this.levelexam
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    unload (e) {
      e = e || window.event
      if (e) {
        // 在这里阻止默认的刷新，弹出弹框
        e.returnValue = '关闭提示'
      }
      return '关闭'
    }
  },
  mounted () {
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })
    window.addEventListener('beforeunload', this.unload)
    // window.addEventListener('beforeunload', e => this.unload) // 注册一个匿名函数
  },
  // 2 销毁这个监听事件
  destroyed () {
    // 销毁这个监听事件，需要找到这个函数，如果使用的是匿名函数的话，无法查找这个函数，这个事件也就没有办法被移除 ，在其他页面仍然会执行这个监听事件
    window.removeEventListener('beforeunload', this.unload)
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/base.scss";
  @import "../../assets/scss/mixin.scss";
  @import "../../assets/scss/config.scss";
  .container{
    box-sizing: border-box;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    .dotest{
      box-sizing: border-box;
      height: 40px;
      width: 100%;
      border-bottom: 1px solid #cecece;
      @include flex();
      margin-top: 30px;
      .left{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #EF0404;
      }
      .right{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        .time{
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #EF0404;
        }
      }
    }
    .dotest_content{
      box-sizing: border-box;
      margin-top: 40px;
      margin-bottom: 90px;
      @include flexed();
      .item_left{
        width: 225px;
        margin-right: 24px;
        .info{
          width: 225px;
          height: 201px;
          border: 1px solid #cecece;
          padding: 20px 30px;
          box-sizing: border-box;
          margin-bottom: 20px;
          .item_title{
            width: 100%;
            text-align: center;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
          .item_info{
            width: 100%;
            text-align: left;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin: 10px 0;
          }
        }
        .selected{
         width: 163px;
         border: 1px solid #cecece;
         padding: 10px 30px;
         margin-bottom: 20px;
         span{
              display: inline-block;
              margin-right: 3px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }
          .item_chess{
            width: 160px;
            height: 40px;
            border: 1px solid #cecece;
            // border-radius: 7px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            text-align: center;
            line-height: 40px;
            margin: auto;
            margin-bottom: 20px;
            cursor: not-allowed;
           color: #333333;
            &:nth-child(3){
              margin-bottom: 0;
            }
          }
          .item-chesses{
              background-color: #008DE9;
              border: 1px solid #008DE9;
              color: #ffffff;
            }
        }
        .select {
          width: 225px;
          border: 1px solid #cecece;
          padding: 10px 30px 20px;
          box-sizing: border-box;
          @include flexed();
          .item_choose{
            width: 20px;
            height: 20px;
            border: 1px solid #cecece;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            text-align: center;
            line-height: 20px;
            margin-top: 10px;
            margin-right: 13px;
            &:nth-child(5n){
              margin-right: 0;
            }
            cursor: pointer;
          }
          .item_chooses{
            background-color: #008DE9;
            border: 1px solid #008DE9;
            color: #ffffff;
          }
        }
      }
      .item-rigts{
        width: 931px;
        border: 1px solid #cecece;
        padding-top: 59px;
        padding-bottom: 59px;
        box-sizing: border-box;
        .cons{
          width: 100%;
          border-bottom: 1px solid #cecece;
          .testtitle{
            width: 100%;
            font-size: 16px;
            margin:0 47px;
            box-sizing: border-box;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            span{
              display: inline-block;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #008DE9;
              margin-right: 10px;
            }
          }
          .testimg{
            width: 268px;
            height: 348px;
            margin:15px 47px;
            box-sizing: border-box;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .selected{
            margin:0 47px;
            margin-top: 5px;
            margin-bottom: 10px;
            box-sizing: border-box;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
        }
        .selects{
          padding:0 47px;
          box-sizing: border-box;
          margin-top: 10px;
          .item_circle{
            display: inline-block;
            margin-right: 32px;
            margin-bottom: 70px;
            .circle{
              width: 12px;
              height: 12px;
              border: 1px solid #999999;
              border-radius: 50%;
              display: inline-block;
            }
            .circles{
              background-color: #008DE9;
            }
            span{
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              display: inline-block;
              margin-left: 8px;
            }
          }
        }
        .btn_box{
          padding-left: 165px;
          box-sizing: border-box;
          .item_box{
            display: inline-block;
            width: 131px;
            height: 52px;
            background: #999999;
            text-align: center;
            line-height: 52px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            margin: 0;
            padding: 0;
            border-radius: 0;
          }
          .item_word{
            display: inline-block;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin-left: 50px;
            margin-right: 50px;
          }
          .item_boxs{
            display: inline-block;
            width: 131px;
            height: 52px;
            background: #008DE9;
            text-align: center;
            line-height: 52px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            margin: 0;
            padding: 0;
            border-radius: 0;
            &:last-child{
              margin-left: 60px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/grading_test/chessCet11.vue